<template>
  <div>
    <label
      :for="`input-${fieldProperties.key}`"
      :style="styleProperty"
      :class="fieldProperties.required ? 'required' : dropdownField.required"
    >
      {{
        $i18n.locale == 'th'
          ? fieldProperties.label_th
          : fieldProperties.label_en
      }}
    </label>
    <v-select
      :id="`input-${fieldProperties.key}`"
      :options="fieldProperties.field_property.value"
      :label="$i18n.locale == 'th' ? 'name_th' : 'name_en'"
      :placeholder="
        $i18n.locale == 'th'
          ? fieldProperties.placeholder_th
          : fieldProperties.placeholder_en
      "
      :style="styleProperty"
      :clearable="fieldProperties.clearable || dropdownField.clearable"
      class="dropdown-field dropdown-item-selected"
      :reduce="(option) => option.value"
      v-model="fieldValue"
      v-if="fieldProperties.required"
    >
      <template #search="{attributes, events}">
        <input
          class="vs__search"
          :required="!fieldValue"
          v-bind="attributes"
          v-on="events"
        />
      </template>
    </v-select>
    <v-select
      :id="`input-${fieldProperties.key}`"
      :options="fieldProperties.field_property.value"
      :label="$i18n.locale == 'th' ? 'name_th' : 'name_en'"
      :placeholder="
        $i18n.locale == 'th'
          ? fieldProperties.placeholder_th
          : fieldProperties.placeholder_en
      "
      :style="styleProperty"
      :clearable="fieldProperties.clearable || dropdownField.clearable"
      v-model="fieldValue"
      class="dropdown-field dropdown-item-selected"
      :reduce="(option) => option.value"
      v-else
    />
  </div>
</template>

<script>
  import vSelect from 'vue-select';
  import { computed, ref, watch } from '@vue/composition-api';
  import { dropdownField } from '@/configs/dynamic-config/dynamic-field';

  export default {
    components: { vSelect },
    props: { fieldProperties: Object },

    setup(props) {
      const fieldValue = ref(props.fieldProperties.value || null);

      const styleProperty = computed(() => {
        return {
          color:
            props.fieldProperties.field_property.color_font ||
            dropdownField.color_font,
          fontSize:
            props.fieldProperties.field_property.font_size ||
            dropdownField.fontSize,
          maxWidth:
            props.fieldProperties.field_property.width || dropdownField.width,
          width: '100%',
        };
      });

      watch(
        () => props.fieldProperties.value,
        () => {
          fieldValue.value = props.fieldProperties.value;
        },
        { deep: true }
      );

      return { styleProperty, dropdownField, fieldValue };
    },
  };
</script>

<style></style>

<style scoped>
  @import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
